'use client'
import Link from 'next/link'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Header from 'components/Header'
import Sponsors from 'components/Sponsors'
import { STRAPI } from 'config/apis'
import { useLeagueContext } from 'utils/context'

const TorMain = () => {
  const pathname = usePathname()
  const { torDetails } = useLeagueContext()

  const [article, setArticle] = useState()
  const [sponsors, setSponsors] = useState()
  const title = torDetails.name
  const sections = torDetails.torUrl.includes('lliga-catalana')
    ? [
        {
          title: 'Lliga Catalana Absoluta',
          link: `${pathname}/absoluta/info`
        },
        {
          title: 'Lliga Catalana de Veterans',
          link: `${pathname}/veterans/info`
        },
        {
          title: 'Lliga Catalana de Veterans Sènior',
          link: `${pathname}/veterans-senior/info`
        },
        {
          title: 'Lliga Catalana de Menors',
          link: `${pathname}/menors/info`
        },
        {
          title: 'Lliga Catalana d’Escoles',
          link: `${pathname}/descoles/info`
        },
        { title: 'Lligues Anteriors', link: `${pathname}/anteriors` }
      ]
    : [
        {
          title: 'Interclubs Femení RACC',
          link: `${pathname}/femeni/info`
        },
        {
          title: 'Interclubs Sènior Barcelona Ciutat',
          link: `${pathname}/senior/info`
        },
        { title: 'Lligues Anteriors', link: `${pathname}/anteriors` }
      ]
  // const textDividerText = 'Inscripcions demà a partir de les 12 hores'

  const getData = async () => {
    try {
      const req = await fetch(
        STRAPI.NEWS_CAT.replace('{cat}', torDetails.newsCat)
      )
      const parsed = await req.json()
      setArticle(parsed?.data?.[0]?.attributes)
      const sponsorsReq = await fetch(STRAPI.SPONSORS)
      const sponsorsRes = await sponsorsReq.json()
      setSponsors(sponsorsRes)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Header img={torDetails.headerImg} title={title} />
      {/* <TextDivider text={textDividerText} /> */}
      <div className="grid grid-cols-1">
        <div className="grid grid-cols-1 lg:flex">
          <div className={`lg:flex-1 bg-${torDetails.color}`}>
            {article && (
              <Link
                href={`/noticies/${article.slug}`}
                className="group grid grid-cols-1 content-between text-blue p-8 h-[230px] lg:h-[455px]"
              >
                <p className="text-[26px] lg:text-[52px] font-alliance-medium leading-tight">
                  <span className="group-hover:border-b-4 border-blue">
                    {article.titulo}
                  </span>
                </p>
                <img
                  src={`/assets/icons/arrow-circle-right.svg`}
                  alt="icon"
                  className="block group-hover:hidden w-10 lg:w-12"
                />
                <img
                  src={`/assets/icons/arrow-circle-right-white.svg`}
                  alt="icon"
                  className="hidden group-hover:block w-10 lg:w-12"
                />
              </Link>
            )}
          </div>
          <div className="lg:flex-1 hidden lg:block grow bg-sec-grey-3 p-8 lg:h-[455px] w-full">
            <p className="lg:text-[52px] font-alliance-medium leading-none">
              {title}
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:flex">
          <div className="lg:flex-1 bg-blue">
            {article && (
              <div
                className={`h-full min-h-[500px] w-full bg-cover hidden lg:block ${
                  article.posicion ? `bg-${article.posicion}` : ''
                }`}
                style={{
                  backgroundImage: `url(
                      ${article.imagen.data.attributes.formats?.large?.url}
                    )`
                }}
              ></div>
            )}
          </div>
          <div className="block lg:hidden grow bg-sec-grey-3 p-8 h-[230px] w-full">
            <p className="text-[34px] font-alliance-medium leading-none">
              {title}
            </p>
          </div>
          <div className="lg:flex-1 grow bg-sec-grey-3 px-8 lg:h-full w-full pb-4">
            {sections.map((item, idx) => {
              return (
                <Link key={idx} href={item.link}>
                  <div
                    className={`group flex justify-between border-b border-black py-4 hover:bg-blue hover:text-white ${
                      idx === 0 ? 'border-t' : null
                    }`}
                  >
                    <p className="text-[18px] lg:text-[34px] ml-2">
                      {item?.title}
                    </p>
                    <img
                      src={`/assets/icons/arrow-circle-right.svg`}
                      alt="icon"
                      className="block group-hover:hidden w-7 lg:w-9 mr-2"
                    />
                    <img
                      src={`/assets/icons/arrow-circle-right-white.svg`}
                      alt="icon"
                      className="hidden group-hover:block w-7 lg:w-9 mr-2"
                    />
                  </div>
                </Link>
              )
            })}
          </div>
        </div>
      </div>
      {/* <Link href="#">
        <div className="group flex justify-between bg-blue hover:bg-sec-grey-5 text-white hover:text-blue py-4 lg:py-8 px-5 lg:px-14">
          <p className="text-[22px] lg:text-[52px] mr-10">
            Descarregar Declaració Responsable
          </p>
          <img
            src={`/assets/icons/download-white.svg`}
            alt="icon"
            className="block group-hover:hidden w-6 lg:w-12"
          />
          <img
            src={`/assets/icons/download.svg`}
            alt="icon"
            className="hidden group-hover:block w-6 lg:w-12"
          />
        </div>
      </Link> */}
      {sponsors && <Sponsors items={sponsors.data.attributes.items} />}
    </>
  )
}

export default TorMain
